import { Pipe, PipeTransform } from '@angular/core';
import { EntityFormField, PheFormData } from '../../../services/entity-type.service';

@Pipe({
    name: 'orderTableFields',
})
export class OrderTableFieldsPipe implements PipeTransform {
    transform(pheFormData: PheFormData, ...args: unknown[]): EntityFormField[] {
        const phe = Array.from(pheFormData.phe.values());
        const pheData = Array.from(pheFormData.pheData.values());
        const fields = [...phe, ...pheData];
        return fields.sort((a, b) => a.displayOrder - b.displayOrder);
    }
}
